import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./CartItems.css";
import { ShopContext } from "../../Context/ShopContext";
import remove_icon from "../Assets/cart_cross_icon.png";

const CartItems = () => {
  const { all_Product = [], cartItems = {}, removeFromCart, getFinalCartAmount, getSubtotalBeforeDiscount } = useContext(ShopContext);
  const navigate = useNavigate();

  if (all_Product.length === 0) {
    return <div className="cartitems">No products available</div>;
  }

  const filteredCartItems = Object.keys(cartItems)
    .filter((id) => cartItems[id]?.quantity > 0)
    .reduce((obj, key) => {
      const product = all_Product.find((product) => product.id === key);
      obj[key] = {
        ...cartItems[key],
        name: product?.name,
        image: product?.image
      };
      return obj;
    }, {});

  const cartProductElements = all_Product
    .filter((product) => filteredCartItems[product.id]?.quantity > 0)
    .map((product) => (
      <div key={product.id}>
        <div className="cartitems-format cartitems-format-main">
          <img src={product.image} alt={product.name} className="carticon-product-icon" />
          <p>{product.name}</p>
          <p>Size: {filteredCartItems[product.id]?.size}</p>
          <p>R{product.new_price.toFixed(2)}</p>
          <button className="cartitems-quantity">{filteredCartItems[product.id].quantity}</button>
          <p>R{(product.new_price * filteredCartItems[product.id].quantity).toFixed(2)}</p>
          <img 
            src={remove_icon} 
            onClick={() => removeFromCart(product.id)} 
            alt="Remove" 
            className="cart-remove-icon"
          />
        </div>
        <hr />
      </div>
    ));

  const subtotal = getSubtotalBeforeDiscount();
  const deliveryFee = subtotal > 1500 ? 0.00 : 100.00;
  const finalTotal = getFinalCartAmount();

  const handleCheckoutClick = () => {
    navigate('/payment', { state: { cartItems: filteredCartItems, subtotal: subtotal, deliveryFee: deliveryFee, totalAmount: finalTotal } });
  };

  return (
    <div className="cartitems">
      <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {cartProductElements.length > 0 ? (
        <>
          {cartProductElements}
          
          
          <div className="cart-summary">
            <div className="cart-summary-item">
              <p>Subtotal:</p>
              <p>R{subtotal.toFixed(2)}</p>
            </div>

            <div className="cart-summary-item">
              <p>Delivery Fee:</p>
              <p>R{deliveryFee.toFixed(2)}</p>
            </div>
            <div className="cart-summary-item" style={{ fontWeight: 'bold', fontSize: '18px', borderTop: '2px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>
              <p>Total:</p>
              <p>R{finalTotal.toFixed(2)}</p>
            </div>
          </div>
          <button className="checkout-button" onClick={handleCheckoutClick}>
            Proceed to Checkout
          </button>
        </>
      ) : (
        <div>No products in the cart</div>
      )}
    </div>
  );
};

export default CartItems;
